
<template>
  <div>
    <v-dialog
      v-model="problem_dialog"
      max-width="500px"
      transition="dialog-transition"
      scrollable
      persistent
    >
      <v-card v-if="problem_dialog" style="border-radius:12px">
        <v-card-title primary-title>
          <div class="title mb-0">Detalhe o motivo e valor do problema/retorno</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref='problemForm' lazy-validation>
            <v-radio-group v-model="kind" row>
              <v-radio label="Cheques com problema" value="checks"></v-radio>
              <!-- <v-radio label="Outro" value="other"></v-radio> -->
            </v-radio-group>

            <!-- <v-text-field :readonly="kind == 'checks'" v-model="problem.returned_due" ref="due" id="due" prepend-icon="mdi-search" label="Razão do problema"></v-text-field> -->

            <template v-if="kind == 'checks'">
              <v-text-field v-model.number="problem.qtd_checks" ref="qtd" id="qtd" :rules="required" prepend-icon="mdi-search" v-mask="'##'" label="Cheques"></v-text-field>

              <div v-for="(ck, idx) in problem.returned_checks" :key="'dvCk'+ck.ref" style="border-radius: 8px; border-left: solid 1px #ccc;" class="pl-2 mb-1">
                <v-subheader class='font-weight-bold primary--text'>Cheque #{{idx + 1}}</v-subheader>
                <v-text-field v-model="ck.number" :rules="ck_number" v-mask="'######'" prepend-icon="mdi-barcode" label="Numero"></v-text-field>
                <v-text-field v-model="ck.motive" :rules="ck_motive" v-mask="'##'" prepend-icon="mdi-information" label="Código do Motivo"></v-text-field>
                <v-text-field v-model="ck.value_aux"  prepend-icon="mdi-currency-brl" label="Valor R$" :rules="not_zero" v-currency="currency"></v-text-field>
                <v-divider></v-divider>
              </div>
            </template>

          </v-form>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn cancel @click="closeDialog()"></f-btn>
          <v-btn color="error" @click="submitProblem()" :disabled="!can_submit" small> <v-icon left size="19">mdi-alert</v-icon> Relatar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="loading"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import {CurrencyDirective} from 'vue-currency-input'
import validations from '@/mixins/validations'
import { mask } from'vue-the-mask'
import Api from '@/api/index';
import status from "@/_backoffice/_financial/mixins/status.js"

export default {
  name: 'DepositProblemDialog',

  mixins: [
    validations, status
  ],
  directives: {
    currency: CurrencyDirective,
    mask,
  },
  props: {
    problem_dialog: {
      type: Boolean,
      default: false
    },
    deposit: {
      type: Object,
    }
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      kind: 'checks',
      default_check: {
        motive: null,
        number: null,
        returned_by: null,
        value: 0,
        value_aux: '0.00',
      },
      problem: {
        returned_due: 'Cheques voltaram',
        qtd_checks: 0,
        returned_value: 0,
        returned_checks: []
      },

      loading: false,
    }
  },
  methods: {
    testReturnedChecksValues() {
      let {returned_checks, qtd_checks, returned_value} = this.problem
      let checks_total_value = 0

      checks_total_value = returned_checks.reduce( (acc, one) => acc + Number(one.value_aux.replace(/,/g, '') ), 0)

      if (checks_total_value > Number(this.deposit.value)) {
        let notification = {}
        notification.type = 'error'
        notification.msg = 'Soma dos cheques maior que depósito'
        this.addNotification(notification)
        return false
      } else {
        return true
      }
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    submitProblem(){
      if (this.$refs.problemForm.validate()){
        if (this.testReturnedChecksValues()) {
          let c = confirm('Deseja salvar os problemas com o depósito?')

          if (c) {
            this.returnDeposit()
          }
        }
      }
    },
    returnDeposit(){
      const {place_id, solution} = this.deposit
      let {returned_checks} = this.problem
      let returned_checks_attributes = returned_checks.map(rc => {
        const {value_aux, ...o} = rc
        return {
          ...o,
          value: Number(value_aux.replace(/,/g, '')),
          returned_by: this.current_user_employee_name,
          place_id,
          solution,
        }
      })
      let obj = {
        id: this.deposit.id,
        returned: true,
        returned_due: this.problem.returned_due,
        returned_value: this.kind == 'other'? this.problem.returned_value : returned_checks_attributes.reduce((acc, one) => acc + one.value, 0),
        returned_checks_attributes,
        status_id: this.status_id_map['Concluded'],
      }
      this.updateDeposit(obj)
    },
    updateDeposit(obj){
      let noti = {
        type: 'success',
        msg: 'Feito com sucesso'
      }
      this.loading = true
      Api.Deposit.update(obj).then(r=>r.data).then(r=> {
        this.$emit('doneReturned')
      }).catch(err=>{
        console.error({err});
        noti = {
          type: 'error',
          msg: `Erro: ${err}`
        }
      }).finally(()=>{
        this.loading = false
        this.addNotification(noti)
      })
    },

  },
  computed: {
    can_submit() {
      return (this.kind == 'checks' && this.problem.qtd_checks > 0) || (this.kind == 'other' && this.problem.returned_due)
    },
  },
  watch: {
    'problem.qtd_checks'(nv,ov) {
      if (nv > ov){
        if (nv <= 20){
          for (let index = 0; index < (nv-ov); index++) {
            this.problem.returned_checks.push({...this.default_check, ref: Math.random()})
          }
        } else {
          this.problem.qtd_checks = 0
          this.problem.qtd_checks = 20
          this.problem.returned_checks = []
        }
      } else if (nv<ov){
        for (let index = 0; index < (ov-nv); index++) {
          this.problem.returned_checks.pop()
        }
      }
    },
    kind(nv,ov) {
      if (nv == 'checks'){
        this.problem.returned_due = 'Cheques voltaram'
      } else{
        this.problem.returned_due = null
        this.problem.returned_value = Number(this.deposit.value)
      }
    }
  },
}
</script>

<style scoped>

</style>
